import { createContext, useContext, useRef } from 'react'

const VNCartContext = createContext(null)

export function VNCartProvider({ children }) {
  const isCartLockedRef = useRef(false)

  const setIsCartLocked = (locked) => {
    isCartLockedRef.current = locked
  }
  const isCartLocked = () => isCartLockedRef.current

  return <VNCartContext.Provider value={{ isCartLocked, setIsCartLocked }}>{children}</VNCartContext.Provider>
}

export function useCartProvider() {
  const context = useContext(VNCartContext)
  if (!context) {
    throw new Error('useCartProvider must be used within a VNCartProvider')
  }
  return context
}
